import intermind from '../../../index';

export class TranslatioResource {
  async enable(conferenceId: string): Promise<void> {
    await intermind.httpClient.patch(`/conferences/${conferenceId}/translation/enable`);
  }

  async disable(conferenceId: string): Promise<void> {
    await intermind.httpClient.patch(`/conferences/${conferenceId}/translation/disable`);
  }
}
